import { DomainNav } from '@cmg/design-system';
import { useParams } from 'react-router-dom';

import { useRoutes } from '../../../../../../../common/hooks/useRoutes/useRoutes';
import { ReactRouterDomainNavTab } from '../../../../../../../design-system/react-router/ReactRouterDomainNavTab';
import { useRoutesMatch } from '../../../../../../../design-system/react-router/useRoutesMatch';
import type { RolodexRecordStatus } from '../../../../../../../graphql';
import { firmDetailGridsRoutes } from './FirmDetailGridsNav.model';
import { useFirmDetailGridsNavActions } from './hooks/useFirmDetailGridsNavActions';

export type FirmDetailGridsNavProps = Readonly<{
  investorContactsCount: number;
  salesCoverageCount: number;
  firmStatus: RolodexRecordStatus;
}>;

export function FirmDetailGridsNav({
  firmStatus,
  investorContactsCount,
  salesCoverageCount,
}: FirmDetailGridsNavProps) {
  const { matchedRouteName, routeNames } = useRoutesMatch(firmDetailGridsRoutes);

  const { firmId = '', crmIntegrationId } = useParams<{
    firmId: string;
    crmIntegrationId?: string;
  }>();

  const actions = useFirmDetailGridsNavActions(firmStatus, matchedRouteName);

  const { crmInvestorFirmSalesCoverageGrid, crmInvestorFirmInvestorContactsGrid } =
    useRoutes(crmIntegrationId);

  return (
    <DomainNav value={matchedRouteName} actions={actions}>
      <ReactRouterDomainNavTab
        value={
          crmIntegrationId
            ? routeNames.sysAdminCrmInvestorFirmSalesCoverageGrid
            : routeNames.customerCrmInvestorFirmSalesCoverageGrid
        }
        label={`Sales Coverage (${salesCoverageCount})`}
        href={crmInvestorFirmSalesCoverageGrid.getUrlPath({ crmIntegrationId, firmId })}
      />
      <ReactRouterDomainNavTab
        value={
          crmIntegrationId
            ? routeNames.sysAdminCrmInvestorFirmInvestorContactsGrid
            : routeNames.customerCrmInvestorFirmInvestorContactsGrid
        }
        label={`Investor Contacts (${investorContactsCount})`}
        href={crmInvestorFirmInvestorContactsGrid.getUrlPath({ crmIntegrationId, firmId })}
      />
    </DomainNav>
  );
}
